import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Invoice } from '@models/invoice.model';
import { IntegrationsDataProvider } from '../../../../../shared/services/integrations/integrations.data.service';
import { finalize } from 'rxjs/operators';
import { MessageService } from '../../../../../shared/services/helpers/message-service/message.service';
import { ConfirmGeneralModalComponent } from '@web-components/common/confirm-general-modal/confirm-general-modal.component';
import { SNModalService } from '@web-services/modal/snModal.service';

@Component({
	selector: 'copy-to-qb-btn',
	template: require('./copy-to-qb-btn.html'),
	styles: [require('./copy-to-qb-btn.scss')]
})
export class CopyToQbBtnComponent implements OnInit {
	@Input() invoiceData: Invoice;
	@Output()
	successGetInvoiceInformation: EventEmitter<Invoice> = new EventEmitter();
	invoiceId: number;
	invoiceDisplayId: string;
	isBtnDisabled: boolean;

	constructor(
		private integrationsDataService: IntegrationsDataProvider,
		private messageService: MessageService,
		private modalService: SNModalService
	) {}

	ngOnInit() {
		this.invoiceId = this.invoiceData.id;
		this.invoiceDisplayId = this.invoiceData.invoiceId;
	}

	copyToQuickbooks(): void {
		const { message } = this.invoiceData.actions.COPY_TO_QB;
		if (message) {
			this.openAlertModal(message);
			return;
		}

		this.isBtnDisabled = true;
		this.integrationsDataService
			.copyInvoiceToQuickbooks(this.invoiceId)
			.pipe(finalize(() => (this.isBtnDisabled = false)))
			.subscribe(
				data => this.successCopyToQuickbooks(data),
				error => this.errorCopyToQuickbooks(error)
			);
	}

	private successCopyToQuickbooks(data: Invoice): void {
		this.successGetInvoiceInformation.emit(data);
		this.messageService.showToaster('s_0', 'qb');
	}

	private errorCopyToQuickbooks(error) {
		const { data, status } = error;
		const errorMessage = data.errorMessage;
		const errorTitle = error.error.errorTitle;
		let errorCode, errorPlace, value;
		if (errorMessage && status >= 400 && status < 500) {
			switch (errorMessage) {
				case "QuickBooks doesn't allow Inclusive tax for US users":
					errorCode = 'e_3';
					errorPlace = 'qb';
					break;
				case 'Invoice with written off payments is not compatible with QuickBooks':
					errorCode = 'e_7';
					errorPlace = 'qb';
					break;
				case 'Sorry, FR QuickBooks companies are not supported yet':
					errorCode = 'e_8';
					errorPlace = 'qb';
					break;
				case 'Invoice with such ID already exists on QuickBooks':
					errorCode = 'e_1';
					errorPlace = 'qb';
					value = this.invoiceData.invoiceId;
					break;
				case 'Invoice with written off payments is not compatible with Xero':
					errorCode = 'e_7';
					errorPlace = 'xero';
					break;
				case 'Invoice has been deleted deleted on QuickBooks':
					errorCode = 'e_17';
					errorPlace = 'qb';
					break;
				case errorMessage.includes(
					'One of the list elements assigned to this transaction has been deleted'
				):
					errorCode = 'e_11';
					errorPlace = 'qb';
					break;
				case errorMessage.includes(
					'Try reselecting the tax rate or reentering the product/service item and saving the form again.'
				):
					errorCode = 'e_19';
					errorPlace = 'qb';
					break;
				case 'Invoice should have the same tax type for all products':
					errorCode = 'e_0';
					errorPlace = 'qb';
					break;
				case "StudioNinja doesn't support transactions with Credit Notes from QuickBooks":
					errorCode = 'e_14';
					errorPlace = 'qb';
					break;

				case 'QB: Impossible to create invoice with Product "Bundle", such item exists on QuickBooks':
					errorCode = 'e_25';
					errorPlace = 'qb';
					break;

				case 'Invoice id length is more than 20':
					errorCode = 'e_27';
					errorPlace = 'qb';
					break;
				case 'Invoice name length is more than 100':
					errorCode = 'e_26';
					errorPlace = 'qb';
					break;
				case errorMessage.includes(
					'QuickBooks: Email Address does not conform to the syntax rules of RFC 822.'
				):
					errorCode = 'e_18';
					errorPlace = 'qb';
					break;
				case 'Invoice description length is more than 4000':
					errorCode = 'e_28';
					errorPlace = 'qb';
					break;
				default:
					if (
						errorTitle &&
						errorTitle !== null &&
						errorMessage &&
						errorMessage !== null
					) {
						this.messageService.showErrorFromBackend(errorTitle, errorMessage);
					} else {
						this.messageService.showErrorFromBackend(
							'Slow down, Quickbooks error!'
						);
					}
					return;
			}
		} else {
			errorCode = 'e_0';
			errorPlace = 'general';
		}
		this.messageService.showToaster(errorCode, errorPlace, value);
	}

	private openAlertModal(message: string): void {
		const modal = this.modalService.openModal(ConfirmGeneralModalComponent, {
			windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
		});
		modal.componentInstance.text = message;

		modal.componentInstance.buttons = [
			{
				text: 'Okay',
				action: 'CLOSE',
				color: 'default',
				size: 'lg'
			}
		];
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/buttons/copy-to-qb-btn/copy-to-qb-btn.ts